export enum MythPassRarity {
    CLASSIC = 1, GOLDEN = 2
}
export enum MythNftTypeIdRarity {
    CLASSIC = 1, GOLDEN = 2
}

export enum MythNFTRarity {
    ALL, CLASSIC = 1, GOLDEN = 2
}

export const MythNFTRarities = {
    ALL: {
        name: "ALL",
        rarityValue: MythNFTRarity.ALL
    },
    CLASSIC: {
        name: "CLASSIC",
        rarityValue: MythNFTRarity.CLASSIC
    },
    GOLDEN: {
        name: "GOLDEN",
        rarityValue: MythNFTRarity.GOLDEN
    },
}

export function getMythPassRarity(passTokenId:number):number{
    if(passTokenId<=5000){
        return MythPassRarity.GOLDEN
    }else{
        return MythPassRarity.CLASSIC
    }
}
